import classNames from 'classnames'
import React from 'react'
import { VideoStop } from '@yy/one-icon'
import { useTranslation } from '../../../hooks'
import Tooltip from '../components/Tooltip'
import styles from './index.module.less'

const BtnRecord: React.FC<React.HTMLAttributes<HTMLDivElement>> = (props) => {
  const { t } = useTranslation()
  return (
    <Tooltip title={t('feedback.stop')}>
      <div className={classNames(styles.btn, styles.closeBtn)} {...props}>
        <VideoStop origin />
      </div>
    </Tooltip>
  )
}

export default BtnRecord
